import React from 'react';
import Content from '../../content';
import Column from '../../column/index';

const Text = ({
  // id,
  columnWidth,
  align,
  justify,
  card,
  order,
  childStrapiPagebuilderPagebuilderBlocksTextContent,
  offset,
}) => (
  <Column
    columnWidth={columnWidth}
    align={align}
    justify={justify}
    card={card}
    order={order}
    offset={offset}
  >
    <Content
      content={childStrapiPagebuilderPagebuilderBlocksTextContent}
      textAlign={justify}
    />
  </Column>
);

export default Text;
